<div class="file-launcher">

  @if (!isCompleted()) {
    <div class="tab-content">
      <div class="tab-inner-content">
        <!-- 1) Upload drop area -->
        @if (status === 'waitingForFile') {
          @if (headerErrors) {
            <div class="file-errors">
              <p>There was a problem with your file:</p>
              <ul>
                @if (headerErrors.missing_required?.length) {
                  <li class="file-errors__error">
                    <div>Missing Required Headers</div>
                    <div class="file-errors__headers">{{headerErrors.missing_required.join(', ')}}</div>
                  </li>
                }
                @if (headerErrors.unknown_header?.length) {
                  <li class="file-errors__error">
                    <div>Unknown Headers</div>
                    <div class="file-errors__headers">{{headerErrors.unknown_header.join(', ')}}</div>
                    @if (headersIncludeSpaces(headerErrors.unknown_header)) {
                      <div class="file-errors__info">One or more of your headers includes spaces, which are not allowed.</div>
                    }
                  </li>
                }
                @if (headerErrors.unsupported_ext?.length) {
                  <li class="file-errors__error">
                    <div>EXT fields not allowed in {{erroredFiletype}} files</div>
                    <div class="file-errors__headers">{{headerErrors.unsupported_ext.join(', ')}}</div>
                  </li>
                }
                @if (headerErrors.unsupported_input?.length) {
                  <li class="file-errors__error">
                    <div>Input fields not allowed in {{erroredFiletype}} files</div>
                    <div class="file-errors__headers">{{headerErrors.unsupported_input.join(', ')}}</div>
                  </li>
                }
              </ul>
            </div>
          }
          <!-- if we have a trigger id, we assume that this file launcher is locked down
          to the 'journey_message' filetype, which is the only one that takes a trigger id -->
          @if (!triggerId) {
            <div class="form-group">
              <select [(ngModel)]="selectedFiletype" class="form-control">
                <option value="messaging">Messaging</option>
                <option value="onboarding">Onboarding</option>
                <option value="cca">CCA</option>
                <option value="phone_management">Phone Management</option>
                <option value="consent_update">Consent Update</option>
                <option value="deactivation">Deactivation</option>
              </select>
            </div>
          }
          <rn-upload-drop-area (fileCaptured)="startUpload($event)" [disabled]="!fileName">
            <span select-btn-text>SELECT FILE</span>
            <p description-text>File format must be CSV</p>
          </rn-upload-drop-area>
          <ng-content select="[cancel-link]"></ng-content>
        }
        <!-- 2 ) upload progress -->
        @if (uploadStatus && status === 'uploading') {
          <rn-upload-progress
            [fileName]="fileName"
          [progressData]="uploadStatus"></rn-upload-progress>
        }
        <!-- 3) choose run or schedule -->
        @if (status === 'waitingForAction') {
          <launch-choice
            [message]="validationMessage | once: fileName: count"
            (launchNow)="onLaunchNowClicked()" (launchOnTimer)="onScheduleClicked()">
          </launch-choice>
        }
      </div>
    </div>
  }

  <message-dialog
    #scheduleWarningDialog
    [showClose]="true"
    [showCancel]="true"
    [affirmButtonText]="'Schedule'"
    [affirmButtonClass]="'btn-primary'"
    [cancelButtonClass]="'btn-link'"
    (affirm)="onConfirmScheduleWarning()">
    <h3>Schedule This File?</h3>
    <p>
      You are about to schedule this file for launch. Please verify that all information is correct before scheduling.
    </p>
  </message-dialog>

  <!-- 4) Schedule Dialog  -->
  @if (status === 'scheduling') {
    <schedule-launch-dialog
      [showDialog]="true"
      [thingBeingLaunched]="'file'"
      [(scheduleTime)]="scheduleTime"
      (confirmTime)="scheduleFile($event)"
      (showDialogChange)="closeScheduleDialog()">
      <ng-container schedule-button-content>
        <span class="btn-label">Schedule</span>
        <span class="icon icon-right"><i aria-hidden="true" class="fa fa-history"></i></span>
      </ng-container>
    </schedule-launch-dialog>
  }

  <!-- 5) Success Messages  -->
  @if (isCompleted()) {
    <rn-launch-result
      [leftButtonLabel]="jobsListOrMonitorBtnTxt"
      (leftButtonClick)="goToMonitorOrJobsList()"
      [rightButtonLabel]="'Upload Again'"
      (rightButtonClick)="reset()">
      @if (status === 'completedRun') {
        <span message>Your File has been added to the Queue and will run shortly</span>
      }
      @if (status === 'completedScheduling') {
        <span message>Your File is scheduled to be added to the Queue at {{scheduleTime | date: 'short' }}.</span>
      }
    </rn-launch-result>
  }

  <message-dialog
    #launchWarningDialog
    [showClose]="true"
    [showCancel]="true"
    [affirmButtonText]="'Launch'"
    [affirmButtonClass]="'btn-primary'"
    [cancelButtonClass]="'btn-link'"
    (affirm)="onConfirmLaunchWarning()">
    <h3>Launch This File?</h3>
    <p>
      You are about to launch this file. Please verify that all information is correct before launching.
    </p>
  </message-dialog>

  <message-dialog #dialog></message-dialog>
</div>
